export default "__VITE_ASSET__SVbtZYG0__"